export default __webpack_public_path__ + "static/tour-use-dont-b24dec676f46e4163523dc6eada1d901.png";